import { useQuery } from "@tanstack/react-query";
import { jeopardyApi } from "../api/jeopardy";
import { useEffect, useState } from "react";

export const useFetchJeopardy = ({ selectedFilterCode, treeFilterCode }: { selectedFilterCode: string | null, treeFilterCode: string | null }) => {

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const changePage = (page: number) => {
        setPage(page);
    };

    const changeRowsPerPage = (limit: number) => {
        setLimit(limit);
    };

    const { data, isLoading, isSuccess, isRefetching, isError, error } = useQuery({
        queryKey: ["jeopardy-listing", page, limit, selectedFilterCode, treeFilterCode],
        queryFn: () => jeopardyApi.fetchJeopardy({ page, limit, filter_code: [...(selectedFilterCode ? [selectedFilterCode] : []), ...(treeFilterCode ? [treeFilterCode] : [])] }),
    });

    useEffect(() => {
        setPage(1);
    }, [selectedFilterCode, treeFilterCode]);

    return { data: isSuccess ? data?.data?.rows : [], pagination: isSuccess ? data?.data?.pagination : {}, isLoading: isLoading || isRefetching, isError, error, changePage, changeRowsPerPage };

};